import React from "react";
import { observer } from "mobx-react";
import Notification from "./notification";
import { RequestStatus } from "../../../services/services/requestStatus";

interface HttpErrorProps {
  requestStatuses?: RequestStatus[];
  defaultErrorMessage?: string;
  type: "http" | "error";
  customizedErrorMessage?: string | React.ReactNode;
}

export function HttpError(props: HttpErrorProps) {
  const errorCodeMap = new Map<string, string>([
    ["zipCode.invalid", "Nie znaleziono podanego kodu pocztowego"],
    ["county.invalid", "Nie znaleziono powiatu dla podanego kodu pocztowego"],
    ["city.invalid", "Nie znaleziono miasta dla podanego powiatu"],
    ["street.invalid", "Nie znaleziono ulicy dla podanego miasta"],
    ["paymentMethod.unavailable", "Wybrano niedostępną formę płatności"],
    ["insurance.endDate.unavailable", "Nieprawidłowa data początku okresu ubezpieczenia"],
    ["insurance.startDate.shouldBeGreaterOrEqualTo.\\d+_\\d+_\\d+", "Nieprawidłowa data początku okresu ubezpieczenia"],
    ["insurance.burglaryAndTheft.movables.individualInsuranceSumInCents.shouldBeLessThanOrEqualTo.\\d+", "Suma ubezpieczenia ruchomości domowych powinna być większa niż suma ubezpieczenie ruchomości domowych od kradzieży z włamaniem i rabunku."],
    ["insurance.burglaryAndTheft.fixedElements.insuranceSum.shouldBeLessThanOrEqualTo.\\d+", "Suma ubezpieczenia stałych elementów od kradzieży z włamaniem i rabunku nie może być większa niż suma ubezpieczenia domu/mieszkania ze stałymi elementami lub tylko stałych elementów."],
    ["client.shouldBeUnique", "Numery PESEL nie mogą się powtarzać"],
    ["accessDenied", "Agent nie posiada dostępu do kalkulacji."],
    ["peselOrRegon.doesNotBelongToInsurerOrInsured", "Podany PESEL/REGON nie znajduje się na polisie"],
    ["insurance.corrections.managerDiscountInPercent.tooHigh", "Zniżka menagerska posiada za wysoką wartość"],
    ["email.invalid", "Nieprawidłowy adres e-mail na który ma zostać wysłany link do dokończenia procesu zakupu"]
  ]);

  const httpCodeMap = new Map<number, string>([
    [401, "Błąd autoryzacji. Możliwe, że Twoja sesja wygasła - spróbuj odświeżyć stronę."]
  ]);

  const filteredRequestStatuses = props.requestStatuses?.filter(x => x !== undefined);
  const parsedErrors = parseHttpErrorCodes(getPartnerApiErrorCodes());
  const httpErrors = getHttpStatusErrors();
  const errors = [...new Set(parsedErrors.concat(httpErrors))];
  const errorMessage = props.defaultErrorMessage || props.customizedErrorMessage;

  if (errors.length > 0) {
    return (
      <div>
        {errors.map((value, index) => {
          return <div key={value}>
            <Notification type={props.type} message={errors[index]} />
          </div>;
        })}
      </div>
    );
  }

  return (<Notification type={props.type} message={errorMessage} />);

  function parseHttpErrorCodes(codes?: string[]) {
    const parsedCodes: string[] = [];
    codes?.forEach(errorCode => {
      errorCodeMap.forEach((value: string, key: string) => {
        if (errorCode.match("^" + key + "$")) {
          parsedCodes.push(value);
        }
      });
    });
    return parsedCodes;
  }

  function getPartnerApiErrorCodes(): string[] | undefined {
    if (!filteredRequestStatuses || !filteredRequestStatuses.length) {
      return undefined;
    }
    return [...new Set(filteredRequestStatuses
      .map((requestStatus) => requestStatus.partnerApiErrorCodes)
      .filter((code) => !!code)
      .reduce((left, right) => left.concat(right), []))];
  }

  function getHttpStatusErrors(): string[] {
    const httpStatusCodes = filteredRequestStatuses?.map(requestStatus => requestStatus.httpStatus);
    const httpStatusErrors: string[] = [];
    httpStatusCodes?.forEach(statusCode => {
      const error = httpCodeMap.get(statusCode);
      if (error) {
        httpStatusErrors.push(error);
      }
    });
    return httpStatusErrors;
  }
}

export default (observer(HttpError));
